import React from 'react';
import { Input } from 'antd';

const SsnLast4Input = ({ value = '', onChange }) => {
  // This function is called when the user types in the active input.
  // It triggers the 'onChange' function passed down from the Form.Item.
  const handleChange = (e) => {
    // Ensure we only pass the numeric value up to the form state
    const numericValue = e.target.value.replace(/[^0-9]/g, '');
    onChange?.(numericValue);
  };

  return (
    <Input.Group compact>
      <Input
        style={{
          width: '100px',
          fontFamily: 'monospace',
          fontSize: '16px',
          color: 'rgba(0, 0, 0, 0.45)',
          backgroundColor: '#f5f5f5',
          textAlign: 'center',
          pointerEvents: 'none',
        }}
        value="###-##-"
        disabled
      />
      <Input
        style={{
          width: '80px',
          fontFamily: 'monospace',
          fontSize: '16px',
          textAlign: 'center',
        }}
        placeholder="1234"
        maxLength={4}
        value={value} // Controlled by the value prop from Form.Item
        onChange={handleChange} // Triggers the onChange prop from Form.Item
      />
    </Input.Group>
  );
};

export default SsnLast4Input;
